import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface FlagSwallowtailProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const FlagSwallowtail: React.FC<FlagSwallowtailProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon flag flag-swallowtail')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path d="M391.4 208l114.1-136.5c6.016-7.156 7.344-17.12 3.406-25.59S497.3 32 487.1 32H48V24C48 10.74 37.25 0 24 0S0 10.74 0 24v464C0 501.3 10.75 512 24 512s24-10.75 24-24V384h439.1c9.326 0 17.83-5.406 21.76-13.88s2.609-18.44-3.406-25.59L391.4 208zM48 336v-256h388.4l-94.77 112.5c-7.516 8.938-7.516 22 0 30.94L436.4 336H48z" />
      </svg>
    </Tooltip>
  );
};
